module.exports = __webpack_public_path__ + "img/bg-init-left.af946a7a.png";